import { IComponentOptions } from "angular";
import { ContractDetailComponentController } from "./controller";

export const vsComponentName = "contractDetailWrapper";

export const contractDetailComponentOptions: IComponentOptions = {
  controller: ContractDetailComponentController,
  controllerAs: "detailController",
  template: require("!html-loader!./index.html").default,
  transclude: true,
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
